<template>
    <w-dialog
        :model-value="show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white"
    >
        <w-flex :gap="3" column>
            <div class="title4">
                {{ title }}
            </div>
            <Table :headers="headers" :items="butiranNotis" :loading="loading">
                <template #item-cell.index="{ index }">
                    {{ index }}
                </template>
                <template #item-cell.tarikh_jana="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_jana">
                            {{ moment(item.tarikh_jana).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_jana).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_jana')"
                        :model-value="moment(item.tarikh_jana).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_jana')"
                        :model-value="moment(item.tarikh_jana).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_tamat="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_tamat">
                            {{ moment(item.tarikh_tamat).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_tamat).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_tamat')"
                        :model-value="moment(item.tarikh_tamat).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_tamat')"
                        :model-value="moment(item.tarikh_tamat).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_terima="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_terima">
                            {{ moment(item.tarikh_terima).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_terima).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_terima')"
                        :model-value="moment(item.tarikh_terima).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_terima')"
                        :model-value="moment(item.tarikh_terima).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_endorse="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_endorse">
                            {{ moment(item.tarikh_endorse).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_endorse).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_endorse')"
                        :model-value="moment(item.tarikh_endorse).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_endorse')"
                        :model-value="moment(item.tarikh_endorse).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_perintah="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_perintah">
                            {{ moment(item.tarikh_perintah).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_perintah).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_perintah')"
                        :model-value="moment(item.tarikh_perintah).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_perintah')"
                        :model-value="moment(item.tarikh_perintah).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_warta="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_warta">
                            {{ moment(item.tarikh_warta).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_warta).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_warta')"
                        :model-value="moment(item.tarikh_warta).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_warta')"
                        :model-value="moment(item.tarikh_warta).format('HH:mm')"
                    />
                </template>
                <template #item-cell.tarikh_siasatan="{ item, index }">
                    <div v-if="index && form.index != index">
                        <span v-if="item.tarikh_siasatan">
                            {{ moment(item.tarikh_siasatan).format('DD/MM/YYYY')}}
                            <br>
                            {{ moment(item.tarikh_siasatan).format('hh:mm a')}}
                        </span>
                    </div>
                    <w-input
                        v-if="form.index == index"
                        type="date"
                        @input="(e)=> setDate(e,'tarikh_siasatan')"
                        :model-value="moment(item.tarikh_siasatan).format('YYYY-MM-DD')"
                    />
                    <w-input
                        v-if="form.index == index"
                        type="time"
                        @input="(e)=>setTime(e,'tarikh_siasatan')"
                        :model-value="moment(item.tarikh_siasatan).format('HH:mm')"
                    />
                </template>
                <template #item-cell.catatan="{ item, index }">
                    <div v-if="index && form.index != index">
                        {{ item.catatan }}
                    </div>
                    <w-input
                        v-if="form.index == index"
                        v-model="form.catatan"
                    >
                    </w-input>
                </template>
                <template #item-cell.no_rujukan="{ item, index }">
                    <div v-if="index && form.index != index">
                        {{ item.no_rujukan }}
                    </div>
                    <w-input
                        v-if="form.index == index"
                        v-model="form.no_rujukan"
                    >
                    </w-input>
                </template>
                <template #item-cell.action="{item, index}">
                    <w-button
                        v-if="form.index != index"
                        @click="
                            form = {
                                ...item,
                                tarikh_tamat: item.tarikh_tamat ? moment(item.tarikh_tamat).format('YYYY-MM-DD') : null,
                                tarikh_jana: item.tarikh_jana ? moment(item.tarikh_jana).format('YYYY-MM-DD') : null,
                                tarikh_terima: item.tarikh_terima ? moment(item.tarikh_terima).format('YYYY-MM-DD') : null,
                                tarikh_endorse: item.tarikh_endorse ? moment(item.tarikh_endorse).format('YYYY-MM-DD') : null,
                                tarikh_perintah: item.tarikh_perintah ? moment(item.tarikh_perintah).format('YYYY-MM-DD') : null,
                                tarikh_warta: item.tarikh_warta ? moment(item.tarikh_warta).format('YYYY-MM-DD') : null,
                                tarikh_siasatan: item.tarikh_siasatan ? moment(item.tarikh_siasatan).format('YYYY-MM-DD') : null,
                                no_rujukan: item.no_rujukan,
                                index
                            };
                        "
                        text
                    >
                        <w-icon> fal fa-pencil </w-icon>
                    </w-button>

                    <w-flex>
                        <w-button text v-if="form.index == index" @click="form = {}" :loading="saving">
                            <w-icon > fal fa-window-close </w-icon>
                        </w-button>

                        <w-button v-if="form.index == index" class="ml3" @click="save()" :loading="saving">
                            <w-icon> fal fa-save </w-icon>
                        </w-button>
                    </w-flex>
                </template>
            </Table>
        </w-flex>

        <template #actions>
            <div class="spacer" />
            <w-button @click="$emit('close')" class="ml3" text>Tutup</w-button>
        </template>
    </w-dialog>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import Table from "../../Component/Table";
import moment from 'moment';
import WaveUI from "wave-ui";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "Butiran Notis",
        },
        show: {
            type: Boolean,
            default: false,
        },
        notis: {
            type: Object,
            default: {},
        },
        searchParams: {
            type: Object,
            default: {},
        },
    },
    components: { Table },
    emits: ["close", "save"],
    setup(props) {
        const waveui = new WaveUI();
        const apiBaseUrl = process.env.MIX_API_BASE_URL;
        const loading = ref(false);
        const saving = ref(false);
        const dialog = ref({
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            width: "90%",
        });

        const headers = ref([
            { label: "#", key: "index" },
            { label: "Tarikh Jana", key: "tarikh_jana" },
            { label: "Tarikh Tamat Notis", key: "tarikh_tamat" },
            { label: "Tarikh Terima", key: "tarikh_terima" },
            { label: "Tarikh Endorse", key: "tarikh_endorse" },
            { label: "Tarikh Perintah", key: "tarikh_perintah" },
            { label: "Tarikh Warta", key: "tarikh_warta" },
            { label: "Tarikh Siasatan", key: "tarikh_siasatan" },
            // { label: "No Rujukan", key: "no_rujukan" },
            { label: "Catatan", key: "catatan" },
            { label: "", key: "action" },
        ]);

        const butiranNotis = ref([]);

        const form = ref({});

        async function fetchData() {
            // console.log(props.searchParams);
            if(typeof props.searchParams.tahun !== "undefined" && props.searchParams.tahun !== null){
                var url = `${apiBaseUrl}/cukai/penguatkuasaan/notis/${props.notis.notis_id}?tahun=${props.searchParams.tahun}`;
            } else {
                var url = `${apiBaseUrl}/cukai/penguatkuasaan/notis/${props.notis.notis_id}`;
            }
            loading.value = true;
            await axios({
                method: "get",
                url: url,
                responseType: "json",
            }).then((e) => {
                butiranNotis.value = e.data.butiran;
            });

            loading.value = false;
        }

        async function save(){
            saving.value = true;
            await axios({
                method: "post",
                url: `${apiBaseUrl}/cukai/penguatkuasaan/notis_butiran`,
                responseType: "json",
                data: form.value
            }).then((e) => {
                waveui.notify({
                    success: true,
                    message: "Berjaya! Maklumat butiran notis telah dikemaskini.",
                    timeout: 3000,
                });
                butiranNotis.value[form.value.index - 1] = e.data;
                form.value = {}
            }).catch(e => {
                waveui.notify({
                    error: true,
                    message: "Ralat",
                    timeout: 3000,
                });
            }).finally(() => {
                saving.value = false;
            });
        }

        function setDate(e,field){
            const temp = moment(form.value[field]).format('hh:mm:ss');
            const time = temp == 'Invalid date' ? '00:00:00' : temp;
            form.value[field] = `${e} ${time}`;
        }

        function setTime(e,field){
            const temp = moment(form.value[field]).format('YYYY-MM-DD');
            const date = temp == 'Invalid date' ? '0000-00-00' : temp;
            form.value[field] = `${date} ${e}:00`;
        }

        watch(
            () => props.show,
            (first, second) => {
                fetchData();
            }
        );
        onMounted(() => {
            fetchData();
        });

        return {
            apiBaseUrl,
            dialog,
            butiranNotis,
            headers,
            loading,
            form,
            moment,
            save,
            saving,
            setDate,
            setTime
        };
    },
});
</script>
